import { registry } from '@cian/mf-registry/browser';

import { IOpenAuthModalParameters } from 'shared/types/microfrontendsAPI';

const HEADER_MICROFRONTEND_NAME = 'header-frontend';
const OPEN_AUTH_MODAL_PATH = '/v3/open-auth-modal/';

/**
 * Гарантирует, что API рантайм микрофронтенда шапки загружен и проинициализирован
 */
export async function ensureHeaderMicrofrontend() {
  return registry().microfrontendStrict(HEADER_MICROFRONTEND_NAME).api()?.ensure();
}

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call(OPEN_AUTH_MODAL_PATH, parameters);
}
